export const parseDurationSeconds = (duration: string): number | undefined => {
  const match = duration.match(/^(\d+(?:\.\d+)?)s$/);
  return match ? Number(match[1]) : undefined;
};
